import { IS_DEV } from "@constants/env";
import { useAppStore } from "@hooks/useAppStore";

export const getClerkPublishableKey = () => {
	const app = useAppStore.getState().app;
	const publishableKey = IS_DEV
		? app.keys.clerk?.publishableKeyDev
		: app.keys.clerk?.publishableKeyProd;
	if (!publishableKey) {
		throw new Error("Clerk publishable key not found");
	}
	return publishableKey;
};
